import React from 'react';

import {Button} from '@albert-io/atomic';

import {useIsAnnotationModeActive} from 'client/components/PracticeView/Annotations/useIsAnnotationModeActive';

import clearGuess from './clearGuess';

interface Props {
  handleResetGuess: () => void;
  questionStoreName: string;
}

export default function TryAgain({handleResetGuess, questionStoreName}: Props) {
  const isAnnotationModeActive = useIsAnnotationModeActive();

  return (
    <Button
      disabled={isAnnotationModeActive}
      type='button'
      onClick={() => {
        global.scrollTo(0, 0);
        handleResetGuess();
        clearGuess(questionStoreName);
      }}
    >
      Try again
    </Button>
  );
}
